module.exports = __webpack_public_path__ + "static/img/yamaxun.4516ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/yamaxun.jpg
// module id = r6Bn
// module chunks = 0